export const AGENDA_COLOR_PRESETS = [
  '#0EA5E9',
  '#2563EB',
  '#4F46E5',
  '#7C3AED',
  '#DB2777',
  '#DC2626',
  '#EA580C',
  '#D97706',
  '#65A30D',
  '#059669',
  '#0891B2',
  '#64748B',
] as const;

const HEX_COLOR_REGEX = /^#([0-9a-f]{6})$/i;

export const normalizeAgendaColor = (value?: string | null): string | null => {
  const normalizedValue = String(value || '').trim();
  if (!normalizedValue) {
    return null;
  }

  const colorValue = normalizedValue.startsWith('#')
    ? normalizedValue
    : `#${normalizedValue}`;

  if (!HEX_COLOR_REGEX.test(colorValue)) {
    return null;
  }

  return colorValue.toUpperCase();
};

export const isAgendaRole = (role?: string | null): boolean =>
  role === 'doctor' || role === 'fisioterapeuta' || role === 'interno';
